/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseRemoveScheduleFromDisplays_ScheduleFragmentDoc } from '../../../__generated__/useRemoveScheduleFromDisplays.graphql';
import { SyncScheduleDisplaysModal_ScheduleFragmentDoc } from '../../../__generated__/SyncScheduleDisplaysModal.graphql';
import { DeleteSchedulesModal_ScheduleFragmentDoc } from '../../../__generated__/DeleteSchedulesModal.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ActionsCell_ScheduleFragment = { __typename: 'Schedule', id: string, isScheduleUsedByAnyConfiguration: boolean, removingDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, allDisplays: Array<{ __typename: 'Display', id: string }> };

export type ScheduleDuplicateMutationVariables = Types.Exact<{
  input: Types.ScheduleDuplicateInput;
}>;


export type ScheduleDuplicateMutation = { __typename: 'Mutation', scheduleDuplicate: { __typename: 'ScheduleDuplicatePayload', schedule: { __typename: 'Schedule', id: string } } };

export const ActionsCell_ScheduleFragmentDoc = gql`
    fragment ActionsCell_schedule on Schedule {
  id
  isScheduleUsedByAnyConfiguration
  removingDisplays: displays(filter: {state: REMOVING}) {
    id
  }
  syncingDisplays: displays(filter: {state: SYNCING}) {
    id
  }
  outOfSyncDisplays: displays(filter: {state: OUT_OF_SYNC}) {
    id
  }
  allDisplays: displays {
    id
  }
  ...useRemoveScheduleFromDisplays_schedule
  ...SyncScheduleDisplaysModal_schedule
  ...DeleteSchedulesModal_schedule
}
    ${UseRemoveScheduleFromDisplays_ScheduleFragmentDoc}
${SyncScheduleDisplaysModal_ScheduleFragmentDoc}
${DeleteSchedulesModal_ScheduleFragmentDoc}`;
export const ScheduleDuplicateDocument = gql`
    mutation ScheduleDuplicate($input: ScheduleDuplicateInput!) {
  scheduleDuplicate(input: $input) {
    schedule {
      id
    }
  }
}
    `;
export type ScheduleDuplicateMutationFn = ApolloReactCommon.MutationFunction<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>;

/**
 * __useScheduleDuplicateMutation__
 *
 * To run a mutation, you first call `useScheduleDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDuplicateMutation, { data, loading, error }] = useScheduleDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>(ScheduleDuplicateDocument, options);
      }
export type ScheduleDuplicateMutationHookResult = ReturnType<typeof useScheduleDuplicateMutation>;
export type ScheduleDuplicateMutationResult = ApolloReactCommon.MutationResult<ScheduleDuplicateMutation>;
export type ScheduleDuplicateMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleDuplicateMutation, ScheduleDuplicateMutationVariables>;